import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';

import { DefaultEditor } from './default-editor';

@Component({
  selector: 'textarea-editor',
  styleUrls: ['./editor.component.scss'],
  template: `
    <textarea
      [ngClass]="inputClass"
      class="form-control"
      [formControl]="formControl"
      [(ngModel)]="cell.newValue"
      [name]="cell.getId()"
      [disabled]="!cell.isEditable()"
      [placeholder]="cell.getTitle()"
      (click)="onClick.emit($event)"
      (keydown.enter)="onEdited.emit($event)"
      (keydown.esc)="onStopEditing.emit()"
    >
    </textarea>
  `,
  standalone: false
})
export class TextareaEditorComponent extends DefaultEditor {
  get formControl(): FormControl {
    return this.cell.getValidator() as FormControl;
  }
  constructor() {
    super();
  }
}